import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BaseService, Callback, ConfigurationService} from '@nh/angular-tses';
import {BehaviorSubject, combineLatest, Subscription} from 'rxjs';
import {DiaryService} from '../../diary/diary.service';
import {PermissionsService} from '../../permissions/permissions.service';
import {AuthoringAction} from '../../permissions/types';
import {WorkflowStates} from '../../workflow/workflow-states';
import {NavigationTarget, RouteService} from '../services/route.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService extends BaseService {
  private toolbarVisible = new BehaviorSubject<boolean>(false);

  constructor(
    snackbar: MatSnackBar,
    configurationService: ConfigurationService,
    private permissionsService: PermissionsService,
    private routeService: RouteService,
    private diaryService: DiaryService
  ) {
    super(snackbar, configurationService);
    this._subscriptions.push(
      combineLatest([
        this.permissionsService.can(AuthoringAction.AUTHOR_SUBMISSIONS_SECTION),
        this.permissionsService.can(AuthoringAction.AUTHOR_SPECIALIST_SECTION),
        this.routeService.onRouting(),
        this.diaryService.onDiarySnapshotChange()
      ]).subscribe(([canAuthorSubmission, canAuthorSesSection, navigationTarget, snapshot]) => {
        if (
          snapshot &&
          snapshot.workflowState &&
          snapshot.workflowState.name &&
          snapshot.workflowState.name !== WorkflowStates.NEED_IDENTIFIED &&
          ((navigationTarget === NavigationTarget.SUBMISSION && canAuthorSubmission) ||
            (navigationTarget === NavigationTarget.SPECIALIST_REVIEW && canAuthorSesSection))
        ) {
          this.setToolbarVisible(true);
        } else {
          this.setToolbarVisible(false);
        }
      })
    );
  }

  private setToolbarVisible(toolbarVisible: boolean): void {
    this.toolbarVisible.next(toolbarVisible);
  }

  public onToolbarVisibilityChange(callback: Callback<boolean>): Subscription {
    const subscription = this.toolbarVisible.subscribe(callback);
    this._subscriptions.push(subscription);
    return subscription;
  }
}
